import { getCurveLength } from '@/_models/virtualStaging/PathFinderLine/utils/getCurveLength';

export const getDistance = (pos1, pos2) => {
  const dx = pos1.x - pos2.x;
  const dy = pos1.y - pos2.y;
  const dz = pos1.z - pos2.z;

  return Math.sqrt(dx * dx + dy * dy + dz * dz);
};

export const getDetailedRouteDistance = (matterPath, THREE) => {
  let fullDistance = 0;
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < matterPath.length; i++) {
    if (matterPath[i] && matterPath[i + 1]) {
      const start = new THREE.Vector3(
        matterPath[i].data.position.x,
        matterPath[i].data.position.y + 0.15,
        matterPath[i].data.position.z,
      );
      const end = new THREE.Vector3(
        matterPath[i + 1].data.position.x,
        matterPath[i + 1].data.position.y + 0.15,
        matterPath[i + 1].data.position.z,
      );
      const path = new THREE.CatmullRomCurve3([start, end]);
      const distance = getCurveLength(path);
      fullDistance += distance;
    }
  }
  return fullDistance;
};

export function checkIntersection(
  point1: Pick<any, 'positionX' | 'positionY' | 'positionZ' | 'isCustom'>,
  point2: Pick<any, 'positionX' | 'positionY' | 'positionZ' | 'isCustom'>,
  barrier: any,
  scene: any,
  THREE: any,
): [] {
  const start = new THREE.Vector3(
    point1.positionX,
    point1.isCustom ? point1.positionY : point1.positionY - 1.15,
    point1.positionZ,
  );
  const end = new THREE.Vector3(
    point2.positionX,
    point2.isCustom ? point2.positionY : point2.positionY - 1.15,
    point2.positionZ,
  );
  const direction = new THREE.Vector3().subVectors(end, start).normalize();

  const raycaster = new THREE.Raycaster(start, direction);
  const intersects = raycaster.intersectObject(barrier, true);

  // Debug method, uncomment to see all sweep connections
  // Red lines represent connections blocked by barriers
  // addDebugLineBetweenPoints(
  //   point1,
  //   point2,
  //   intersects.length > 0 ? 0xff0000 : 0x0000ff,
  //   scene,
  //   THREE
  // );

  return intersects;
}

export const getClosestSweep = (
  startPointPosition: any,
  sweeps: any[] | undefined,
  sceneBarrierNodes: Map<number, any> | [],
  THREE: any,
): any | null => {
  if (!sweeps) return null;
  // const THREE = context.current.three;

  let minDistance = 10;
  let minDistanceSweep = null;

  sweeps.forEach((sweep: any) => {
    const sweepPos = new THREE.Vector3(
      sweep.position.x,
      sweep.isCustom ? sweep.position.y : sweep.position.y - 1.15,
      sweep.position.z,
    );

    const distance = sweepPos.distanceTo(startPointPosition);
    if (distance > minDistance) return;

    let intersectsBarrier = false;
    sceneBarrierNodes.forEach((barrierNode: any) => {
      const intersects = checkIntersection(
        sweep,
        {
          positionX: startPointPosition.x,
          positionY: startPointPosition.y,
          positionZ: startPointPosition.z,
          isCustom: true,
        },
        barrierNode[0].obj3D,
        barrierNode[1].context.scene,
        THREE,
      );
      if (intersects.length) {
        let isBarrierFront = false;
        intersects.every((i: any) => {
          if (i.object.name === 'barrierFront' && i.object.visible) {
            isBarrierFront = true;
            return false;
          }
          if (i.object.name === 'barrierBack' && i.object.visible) {
            return false;
          }
          return true;
        });
        if (isBarrierFront) return;
        intersectsBarrier = true;
      }
    });

    // If intersects polygon, skip this sweep connection
    if (intersectsBarrier) return;

    if (distance < minDistance) {
      minDistance = distance;
      minDistanceSweep = sweep;
    }
  });

  return minDistanceSweep;
};
